<template>
  <router-view />
</template>

<script>
export default {
  name: "fabricate",
};
</script>